import { render, staticRenderFns } from "./StakingPoolConfig.vue?vue&type=template&id=6f680ed7&scoped=true&"
import script from "./StakingPoolConfig.vue?vue&type=script&lang=js&"
export * from "./StakingPoolConfig.vue?vue&type=script&lang=js&"
import style0 from "./StakingPoolConfig.vue?vue&type=style&index=0&id=6f680ed7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f680ed7",
  null
  
)

export default component.exports